export default "__VITE_PUBLIC_ASSET__1f7b9eed__"